<svg width="38" height="30" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2229_6271)">
<g clip-path="url(#clip1_2229_6271)">
<path d="M31.6384 5.99841L28.7576 8.00171L25.8767 5.99841" stroke="currentColor"/>
<rect x="3.5" y="11" width="31" height="1" fill="currentColor"/>
<g clip-path="url(#clip2_2229_6271)">
<rect x="6.5" y="15.25" width="6.92581" height="1" fill="currentColor"/>
<rect opacity="0.1" x="3.27295" y="19.5" width="31.2271" height="8.29999" fill="currentColor"/>
<rect x="6.5" y="22.75" width="5.21841" height="1" fill="currentColor"/>
</g>
</g>
<rect x="2.8" y="2.3" width="32.4" height="25.4" rx="2.2" stroke="currentColor" stroke-width="1.4"/>
</g>
<defs>
<clipPath id="clip0_2229_6271">
<rect width="38" height="30" rx="3" fill="white"/>
</clipPath>
<clipPath id="clip1_2229_6271">
<rect x="3.5" y="3" width="31" height="24" rx="1.5" fill="white"/>
</clipPath>
<clipPath id="clip2_2229_6271">
<rect width="31" height="15" fill="white" transform="translate(3.5 12)"/>
</clipPath>
</defs>
</svg>
